// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"540bd904","94":"98d555d7","239":"3fec4b50","259":"8a521c97","451":"13723418","512":"97629025","525":"a19eb20d","553":"c2104ea3","792":"7a346a78","907":"fb39a9c8","964":"676ebfb1","965":"b8723234"}[chunkId] + ".chunk.js";
};